if (!customElements.get('ca-signup')) customElements.define('ca-signup', class extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.form = this.querySelector('form');
    this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
    this.status = this.querySelector('[role=status]');
    this.button = this.querySelector('[type=submit]');
    this.details = this.querySelector('details');
    this.details.addEventListener('toggle', () => {
      this.querySelector('[data-show]').hidden = this.details.open;
      this.querySelector('[data-hide]').hidden = !this.details.open;
    });
    this.placement = this.dataset.placement === 'popup' ? 'popup' : 'homepage';
    this.querySelector('.ca-signup-dismiss').addEventListener('click', () => this.dismiss());
    this.form.elements.smsConsent.addEventListener('change', () => this.updateSms());
    this.form.addEventListener('submit', (event) => this.submit(event));
    try {
      const result = await this.request();
      if (result.audience === 'hidden') return;
      this.audience = result.audience;
      this.querySelector('[data-sms-choice]').hidden = !result.smsEnabled;
      if (this.audience === 'email') {
        this.querySelector('[data-intro]').textContent = this.messages.introSms;
        this.querySelector('[data-email-label]').hidden = true;
        this.querySelector('[data-email-terms]').hidden = true;
        this.querySelector('[data-sms-label]').textContent = this.messages.smsRequired;
        this.form.elements.smsConsent.required = true;
        if (!this.form.elements.email.value) return;
      }
      if (this.doneSeen()) return;
      if (this.placement === 'popup') this.schedulePopup();
      else this.hidden = false;
    } catch { this.hidden = true; }
  }
  get popupKey() { return 'ca-signup-popup'; }
  get doneKey() { return 'ca-signup-done'; }
  doneSeen() {
    try { return Number(localStorage.getItem(this.doneKey) || 0) > Date.now(); } catch { return false; }
  }
  rememberDone(days) {
    try { localStorage.setItem(this.doneKey, String(Date.now() + days * 86400000)); } catch {}
  }
  finish(message, code) {
    this.classList.add('ca-signup--done');
    this.form.hidden = true;
    this.status.textContent = '';
    this.details.open = false;
    const heading = this.querySelector('[data-heading]');
    heading.textContent = code ? this.messages.issued.replace('[code]', code) : message;
    if (code) {
      const shop = this.querySelector('.ca-signup-shop');
      const redirect = '/pages/welcome?utm_source=catchamerica&utm_medium=signup&utm_campaign=welcome_signup&utm_content=homepage';
      shop.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;
      shop.hidden = false;
      shop.addEventListener('click', (event) => event.stopPropagation());
      heading.append(shop);
      setTimeout(() => location.assign(shop.href), 2500);
    }
    this.querySelector('summary').focus();
    this.rememberDone(7);
    if (this.placement === 'popup') this.rememberPopup(365);
    setTimeout(() => {
      this.classList.add('ca-signup--leaving');
      setTimeout(() => { this.hidden = true; }, 450);
    }, 8000);
  }
  popupSeen() {
    try { return Number(localStorage.getItem(this.popupKey) || 0) > Date.now(); } catch { return false; }
  }
  rememberPopup(days) {
    try { localStorage.setItem(this.popupKey, String(Date.now() + days * 86400000)); } catch {}
  }
  schedulePopup() {
    if (this.popupSeen()) return;
    const delay = Math.min(60, Math.max(3, Number(this.dataset.delay) || 8)) * 1000;
    setTimeout(() => {
      if (this.popupSeen()) return;
      this.hidden = false;
      this.details.open = true;
      this.form.elements.email.focus({ preventScroll: true });
    }, delay);
    this.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.dismiss(); });
    this.querySelector('.ca-signup-backdrop')?.addEventListener('click', () => this.dismiss());
  }
  dismiss() {
    if (this.placement === 'popup') {
      this.rememberPopup(this.form.hidden ? 365 : 30);
      this.hidden = true;
      return;
    }
    this.details.open = false;
    this.querySelector('summary').focus();
  }
  async request(body) {
    const response = await fetch(this.dataset.endpoint, {
      method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin', cache: 'no-store',
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || 'signupUnavailable');
    return result;
  }
  updateSms() {
    const selected = this.form.elements.smsConsent.checked;
    this.querySelector('[data-phone]').hidden = !selected;
    this.querySelector('[data-sms-terms]').hidden = !selected;
    this.form.elements.phone.required = selected;
  }
  async submit(event) {
    event.preventDefault();
    if (this.button.disabled) return;
    this.button.disabled = true;
    this.button.textContent = this.messages.working;
    this.status.textContent = '';
    try {
      const fields = this.form.elements;
      const rawPhone = fields.phone.value.replace(/[^\d+]/g, '');
      const phone = rawPhone.startsWith('+') ? rawPhone : `+${rawPhone.length === 10 ? '1' : ''}${rawPhone}`;
      const result = await this.request({
        email: fields.email.value.trim(), emailConsent: this.audience !== 'email',
        smsConsent: fields.smsConsent.checked,
        ...(fields.smsConsent.checked ? { phone } : {}),
        website: fields.website.value, placement: this.placement, consentVersion: '2026-10-23'
      });
      this.finish(this.messages[result.status] || this.messages.signupUnavailable, /^\d{7}$/.test(result.code || '') ? result.code : undefined);
    } catch (error) {
      this.status.textContent = this.messages[error.message] || this.messages.signupUnavailable;
    } finally {
      this.button.disabled = false;
      this.button.textContent = this.messages.join;
    }
  }
});
